import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { map,takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {AuthenticationService} from './authentication.service';

import * as FileSaver from 'file-saver';  
import * as XLSX from 'xlsx';  
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';  
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private destroy$: Subject<void> = new Subject<void>();
  private extUrl = environment.extUrl;
  private localurl=environment.apiUrl;
  public clientusername:any;
  public appname="";
  PanindiaRegions = ['Maharashtra', 'Punjab', 'Gujarat', 'Delhi', 'West Bengal', 'Odisha', 'Assam', 'Arunachal Pradesh', 'Tripura', 'Mizoram', 'Bihar', 'Jharkhand', 'Uttar Pradesh', 'Andhra Pradesh', 'Telangana', 'Tamil Nadu', 'Karnataka', 'Madhya Pradesh', 'Chhattisgarh', 'Rajasthan', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Kerala', 'Uttarakhand', 'Goa','Manipur','Nagaland','Meghalaya']
  timelap="";
  //EAIFlg
  eaiFlag:boolean;
  xauthuser="citUser";
  xauthtoken= "Pass@1234";
  // origin="https://cdbeai.europ-assistance.in/"
  constructor(private http: HttpClient, private router: Router,private _AuthenticationService:AuthenticationService) { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {  
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);  
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };  
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });  
    this.saveAsExcelFile(excelBuffer, excelFileName);  
  }  
  private saveAsExcelFile(buffer: any, fileName: string): void {  
     const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});  
     FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);  
  }
  
  getRosData(client,subregion, daysData, filterByCaseStatus, CaseStatusList, createdByNames=[]) {
    // console.log('schema names at getBDCasesReport',client);
    // console.log('this.eaiFlag',this.eaiFlag);
    let newClient = []
 {/*    if(localStorage.getItem('clientIDE') === 'Royal Enfield RSA'){
      newClient = ["ROENRSA", "ROENRTL"]
    }
    else if(localStorage.getItem('clientIDE') === 'Jaguar'){
      newClient = ["Jaguar"]
    } else
    if(localStorage.getItem('clientIDE') == 'Mahindra Verito RSA') {
      newClient = ['MHDRRERSA', 'MHDRVERSA', 'MHDR_3W_CV', 'MHDR_CV_Retail', 'BOLERO_Neo', 'BOLERO_Retail', 'MHDR_BOLERO_CV_Retail']
    } 
    else if(localStorage.getItem('clientIDE') == 'MG MOTORS') {
      newClient = ['MG_MOTORS', 'MG_RETAIL']
    } 
    else if(localStorage.getItem('clientIDE') == 'AtherEnergyRSA') {
      newClient = ['ATHER_RSA']
    }*/}
    if(subregion=="Panindia"){
      subregion=this.PanindiaRegions
    }
    else{
      subregion=[subregion];
    }
    return this.http.post<any>(`${this.localurl}api/getBDCasesReport`, {
      subregion : subregion,
      "client": client,
      "createdByNames": createdByNames,
      "ServiceType":["RRP"],
      "LocationType":["On Road","Home/Office"],
      "ETAExceededReason":["","Deferred"],
      "timeLap": "90",
      "EAIFlg":this.eaiFlag,
      "daysData": daysData,
      "filterByCaseStatus": filterByCaseStatus
    })
      .pipe(map(data => {
        return data
      }));
  };

  getTowData(client,subregion, daysData, filterByCaseStatus, CaseStatusList, createdByNames=[]) {
    let newClient = []
    {/* 
    if(localStorage.getItem('clientIDE') === 'Royal Enfield RSA'){
      newClient = ["ROENRSA", "ROENRTL"]
    }
    else if(localStorage.getItem('clientIDE') === 'Jaguar'){
      newClient = ["Jaguar"]
    }else
    if(localStorage.getItem('clientIDE') == 'Mahindra Verito RSA') {
      newClient = ['MHDRRERSA', 'MHDRVERSA', 'MHDR_3W_CV', 'MHDR_CV_Retail', 'BOLERO_Neo', 'BOLERO_Retail', 'MHDR_BOLERO_CV_Retail']
    } 
    else if(localStorage.getItem('clientIDE') == 'MG MOTORS') {
      newClient = ['MG_MOTORS', 'MG_RETAIL']
    } 
    else if(localStorage.getItem('clientIDE') == 'AtherEnergyRSA') {
      newClient = ['ATHER_RSA']
    } */}
    if(subregion=="Panindia"){
      subregion=this.PanindiaRegions
    }else{
      subregion=[subregion];
    }
    return this.http.post<any>(`${this.localurl}api/getBDCasesReport`, {
      subregion : subregion,
      "client": client,
      "createdByNames": createdByNames,
      "LocationType":["On Road","Home/Office"],
      "ServiceType":["TOW"],
      "ETAExceededReason":["","Deferred"],
      "timeLap": "90",
      "EAIFlg":this.eaiFlag,
      "daysData": daysData,
      "filterByCaseStatus": filterByCaseStatus
    })
      .pipe(map(data => {
        return data
      }));
  };

  getAllDataOneMonth(client,subregion, daysData, filterByCaseStatus, CaseStatusList, createdByNames=[]) {
    let fromDate = new Date()
    fromDate.setMonth(fromDate.getMonth()-1);
    fromDate.setDate(fromDate.getDate() + 1);
    var day = fromDate.getDate()
    var month = fromDate.getMonth() + 1
    var year = fromDate.getFullYear()
    let fromNewDate = year + "-" + month + "-" + day
    let newClient = []
    if(subregion=="Panindia"){
      subregion=this.PanindiaRegions
    }
    else{
      subregion=[subregion];
    }
    return this.http.post<any>(`${this.localurl}api/getBDCasesReport`, {
      subregion : subregion,
      "client": client,
      "createdByNames": createdByNames,
      "ServiceType":["RRP", "TOW", "Custody"],
      "LocationType":["On Road","Home/Office"],
      "ETAExceededReason":["","Deferred"],
      // "timeLap": this.timelap,
      "EAIFlg":this.eaiFlag,
      "fromDate": fromNewDate
    })
      .pipe(map(data => {
        return data
      }));
  }

  getRosDataOneMonth(client,subregion, daysData, filterByCaseStatus, CaseStatusList, createdByNames=[]) {
    let fromDate = new Date()
    fromDate.setMonth(fromDate.getMonth()-1);
    fromDate.setDate(fromDate.getDate() + 1);
    var day = fromDate.getDate()
    var month = fromDate.getMonth() + 1
    var year = fromDate.getFullYear()
    let fromNewDate = year + "-" + month + "-" + day
    let newClient = []
    {/* 
    if(localStorage.getItem('clientIDE') === 'Royal Enfield RSA'){
      newClient = ["ROENRSA", "ROENRTL"]
    }
    else if(localStorage.getItem('clientIDE') === 'Jaguar'){
      newClient = ["Jaguar"]
    }else
    if(localStorage.getItem('clientIDE') == 'Mahindra Verito RSA') {
      newClient = ['MHDRRERSA', 'MHDRVERSA', 'MHDR_3W_CV', 'MHDR_CV_Retail', 'BOLERO_Neo', 'BOLERO_Retail', 'MHDR_BOLERO_CV_Retail']
    } 
    else if(localStorage.getItem('clientIDE') == 'MG MOTORS') {
      newClient = ['MG_MOTORS', 'MG_RETAIL']
    } 
    else if(localStorage.getItem('clientIDE') == 'AtherEnergyRSA') {
      newClient = ['ATHER_RSA']
    } */}
    if(subregion=="Panindia"){
      subregion=this.PanindiaRegions
    }
    else{
      subregion=[subregion];
    }
    return this.http.post<any>(`${this.localurl}api/getBDCasesReport`, {
      subregion : subregion,
      "client": client,
      "createdByNames": createdByNames,
      "ServiceType":["RRP"],
      "LocationType":["On Road","Home/Office"],
      "ETAExceededReason":["","Deferred"],
      // "timeLap": this.timelap,
      "EAIFlg":this.eaiFlag,
      "fromDate": fromNewDate
    })
      .pipe(map(data => {
        return data
      }));
  };

  getTowDataOneMonth(client,subregion, daysData, filterByCaseStatus, CaseStatusList, createdByNames=[]) {

    let fromDate = new Date()
    fromDate.setMonth(fromDate.getMonth()-1);
    fromDate.setDate(fromDate.getDate() + 1);
    var day = fromDate.getDate()
    var month = fromDate.getMonth() + 1
    var year = fromDate.getFullYear()
    let fromNewDate = year + "-" + month + "-" + day
    let newClient = []
    {/*
    if(localStorage.getItem('clientIDE') === 'Royal Enfield RSA'){
      newClient = ["ROENRSA", "ROENRTL"]
    }
    else if(localStorage.getItem('clientIDE') === 'Jaguar'){
      newClient = ["Jaguar"]
    }else
    if(localStorage.getItem('clientIDE') == 'Mahindra Verito RSA') {
      newClient = ['MHDRRERSA', 'MHDRVERSA', 'MHDR_3W_CV', 'MHDR_CV_Retail', 'BOLERO_Neo', 'BOLERO_Retail', 'MHDR_BOLERO_CV_Retail']
    } 
    else if(localStorage.getItem('clientIDE') == 'MG MOTORS') {
      newClient = ['MG_MOTORS', 'MG_RETAIL']
    } 
    else if(localStorage.getItem('clientIDE') == 'AtherEnergyRSA') {
      newClient = ['ATHER_RSA']
    }  */}
    if(subregion=="Panindia"){
      subregion=this.PanindiaRegions
    }else{
      subregion=[subregion];
    }
    return this.http.post<any>(`${this.localurl}api/getBDCasesReport`, {
      subregion : subregion,
      "client": client,
      "createdByNames": createdByNames,
      "LocationType":["On Road","Home/Office"],
      "ServiceType":["TOW"],
      "ETAExceededReason":["","Deferred"],
      // "timeLap":this.timelap,
      "EAIFlg":this.eaiFlag,
      "fromDate": fromNewDate
    })
      .pipe(map(data => {
        return data
      }));
  };

  getCustodyDataOneMonth(client,subregion, daysData, filterByCaseStatus, CaseStatusList, createdByNames=[]) {

    let fromDate = new Date()
    fromDate.setMonth(fromDate.getMonth()-1);
    fromDate.setDate(fromDate.getDate() + 1);
    var day = fromDate.getDate()
    var month = fromDate.getMonth() + 1
    var year = fromDate.getFullYear()
    let fromNewDate = year + "-" + month + "-" + day
    let newClient = []
    {/* 
    if(localStorage.getItem('clientIDE') === 'Royal Enfield RSA'){
      newClient = ["ROENRSA", "ROENRTL"]
    }
    else if(localStorage.getItem('clientIDE') === 'Jaguar'){
      newClient = ["Jaguar"]
    }else
    if(localStorage.getItem('clientIDE') == 'Mahindra Verito RSA') {
      newClient = ['MHDRRERSA', 'MHDRVERSA', 'MHDR_3W_CV', 'MHDR_CV_Retail', 'BOLERO_Neo', 'BOLERO_Retail', 'MHDR_BOLERO_CV_Retail']
    } 
    else if(localStorage.getItem('clientIDE') == 'MG MOTORS') {
      newClient = ['MG_MOTORS', 'MG_RETAIL']
    } 
    else if(localStorage.getItem('clientIDE') == 'AtherEnergyRSA') {
      newClient = ['ATHER_RSA']
    } */}
    if(subregion=="Panindia"){
      subregion=this.PanindiaRegions
    }else{
      subregion=[subregion];
    }
    return this.http.post<any>(`${this.localurl}api/getBDCasesReport`, {
      subregion : subregion,
      "client": client,
      "createdByNames": createdByNames,
      "LocationType":["On Road","Home/Office"],
      "ServiceType":["Custody"],
      "ETAExceededReason":["","Deferred"],
      // "timeLap":this.timelap,
      "EAIFlg":this.eaiFlag,
      "fromDate": fromNewDate
    })
      .pipe(map(data => {
        return data
      }));
  };


  getRosTowData(client,subregion, daysData, filterByCaseStatus, CaseStatusList, createdByNames=[]) {
    let newClient = []
    {/* 
    if(localStorage.getItem('clientIDE') === 'Royal Enfield RSA'){
      newClient = ["ROENRSA", "ROENRTL"]
    }
    else if(localStorage.getItem('clientIDE') === 'Jaguar'){
      newClient = ["Jaguar"]
    }else
    if(localStorage.getItem('clientIDE') == 'Mahindra Verito RSA') {
      newClient = ['MHDRRERSA', 'MHDRVERSA', 'MHDR_3W_CV', 'MHDR_CV_Retail', 'BOLERO_Neo', 'BOLERO_Retail', 'MHDR_BOLERO_CV_Retail']
    } 
    else if(localStorage.getItem('clientIDE') == 'MG MOTORS') {
      newClient = ['MG_MOTORS', 'MG_RETAIL']
    } 
    else if(localStorage.getItem('clientIDE') == 'AtherEnergyRSA') {
      newClient = ['ATHER_RSA']
    } */}
    if(subregion=="Panindia"){
      subregion=this.PanindiaRegions
    }
    else{
      subregion=[subregion];
    }
    return this.http.post<any>(`${this.localurl}api/getBDCasesReport`, {
      subregion : subregion,
      "client": client,
      "createdByNames": createdByNames,
      "ServiceType":["RRP", 'TOW'],
      "LocationType":["On Road","Home/Office"],
      "ETAExceededReason":["","Deferred"],
      "timeLap": "90",
      "EAIFlg":this.eaiFlag
    })
      .pipe(map(data => {
        return data
      }));
  };
  getTowDefferedData(client,subregion, createdByNames=[]) {
    // this.gettimelap()
    const headers = new HttpHeaders({
      'x-auth-user': this.xauthuser,
      'x-auth-token': this.xauthtoken
    });
    return this.http.post<any>(`${this.extUrl}api/citExt/getCasesReportBasedOnVendor`, {
      subregion : subregion,
      "client": client,
      "createdByNames": createdByNames,
      "LocationType":"Home/Office",
      "ServiceType":"TOW",
      "ETAExceededReason":"Deferred",
      "timeLap": this.timelap,
    }, { headers: headers })
      .pipe(map(data => {
        return data
      }));
  };

  getRosdeffereddData(client,subregion, createdByNames=[]) {
    // this.gettimelap()
    let newClient = []
    {/* 
    if(localStorage.getItem('clientIDE') === 'Royal Enfield RSA'){
      newClient = ["ROENRSA", "ROENRTL"]
    }
    else if(localStorage.getItem('clientIDE') === 'Jaguar'){
      newClient = ["Jaguar"]
    }else
    if(localStorage.getItem('clientIDE') == 'Mahindra Verito RSA') {
      newClient = ['MHDRRERSA', 'MHDRVERSA', 'MHDR_3W_CV', 'MHDR_CV_Retail', 'BOLERO_Neo', 'BOLERO_Retail', 'MHDR_BOLERO_CV_Retail']
    } 
    else if(localStorage.getItem('clientIDE') == 'MG MOTORS') {
      newClient = ['MG_MOTORS', 'MG_RETAIL']
    } 
    else if(localStorage.getItem('clientIDE') == 'AtherEnergyRSA') {
      newClient = ['ATHER_RSA']
    } */}
    const headers = new HttpHeaders({
      'x-auth-user': this.xauthuser,
      'x-auth-token': this.xauthtoken
    });
    return this.http.post<any>(`${this.extUrl}api/citExt/getCasesReportBasedOnVendor`, {
      subregion : subregion,
      "client": newClient,
      "createdByNames": createdByNames,
      "ServiceType":"RRP",
      "LocationType":"Home/Office",
      "ETAExceededReason":"Deferred",
      "timeLap": "90",
    }, { headers: headers })
      .pipe(map(data => {
        return data
      }));
  };

  //get clientname based on client description
  getclient(clientedesc){
    return this.http.post<any>(`${this.localurl}api/clientName`,{ClientNameDesc:clientedesc})
      .pipe(map(data => {
          return data
      }));
  }

  getRegionsBasedonUser(username){
    return this.http.post<any>(`${this.localurl}api/getClientRMRegions`,{username: localStorage.getItem('userName')+localStorage.getItem('firstName')})
    .pipe(map(data => {
        return data
    }));
  }

  getRegionforEaiuser(username){
    const headers = new HttpHeaders({
      'x-auth-user': this.xauthuser,
      'x-auth-token': this.xauthtoken
    });
    return this.http.post<any>(`${this.extUrl}api/citExt/getRegionForRM`,{username:username}, { headers: headers })
    .pipe(map(data => {
        return data
    }));
  }


  gettimelap(){
    
  this._AuthenticationService.getUserData()
  .pipe(takeUntil(this.destroy$))
  .subscribe((users: any) => {
    this.clientusername = users.data.username;
    this.appname=users.data.application;
    let email = localStorage.getItem('email');
          if(email.includes('extern@europ-assistance.in')){
            this.eaiFlag=true;
            console.log("this.eaiFlag ros",this.eaiFlag)
            
          }else{
            this.eaiFlag=false;
            console.log("this.eaiFlag ros false",this.eaiFlag)
          }
  //  this._AuthenticationService.getusercontroldata(localStorage.getItem('lastName')+localStorage.getItem('firstName'),this.appname)
  //    .subscribe(res=>{
  //      console.log("timer2",res)
  //        console.log("timer",res.data[1].email)
  //        console.log("timer1",res.data[3].timeLap)
  //        console.log("timer2",res)
       //   let email=res.data[1].email;   
  //        this.timelap= res.data[3].timeLap
  //    })
  });
  }


  getdenialCases(fromdate,todate,subregion,client, createdByNames=[]){
    let newClient = []
    {/* 
    if(localStorage.getItem('clientIDE') === 'Royal Enfield RSA'){
      newClient = ["ROENRSA", "ROENRTL"]
    }
    else if(localStorage.getItem('clientIDE') === 'Jaguar'){
      newClient = ["Jaguar"]
    }else
    if(localStorage.getItem('clientIDE') == 'Mahindra Verito RSA') {
      newClient = ['MHDRRERSA', 'MHDRVERSA', 'MHDR_3W_CV', 'MHDR_CV_Retail', 'BOLERO_Neo', 'BOLERO_Retail', 'MHDR_BOLERO_CV_Retail']
    } 
    else if(localStorage.getItem('clientIDE') == 'MG MOTORS') {
      newClient = ['MG_MOTORS', 'MG_RETAIL']
    } 
    else if(localStorage.getItem('clientIDE') == 'AtherEnergyRSA') {
      newClient = ['ATHER_RSA']
    } */}
    if(subregion=="Panindia"){
      subregion=this.PanindiaRegions
    }else{
      subregion=[subregion];
    }
    return this.http.post<any>(`${this.localurl}api/getEzAutoDenielReport`, {
      "fromdate":fromdate,
      "todate":todate,
      "subregion":subregion,
      "client":client,
      "createdByNames": createdByNames,
    })
      .pipe(map(data => {
        return data
      }));

  }

  getPendingActivationData(){
    return this.http.post<any>(`${this.localurl}api/getVendorNotAssignedBDCasesReport`,{})
      .pipe(map(data=>{
        return data
      }))
  }
  getPendingActivationDataNew(){
    return this.http.post<any>(`${this.localurl}api/getSelectedServices`,{})
      .pipe(map(data=>{
        return data
      }))
  }
  getPendingActivationDatabasedOnClient(client){
    // console.log(client, 'client description')
    let newClient = []
    {/* 
    if(localStorage.getItem('clientIDE') === 'Royal Enfield RSA'){
      newClient = ["ROENRSA", "ROENRTL"]
    }
    else if(localStorage.getItem('clientIDE') === 'Jaguar'){
      newClient = ["Jaguar"]
    }else
    if(localStorage.getItem('clientIDE') == 'Mahindra Verito RSA') {
      newClient = ['MHDRRERSA', 'MHDRVERSA', 'MHDR_3W_CV', 'MHDR_CV_Retail', 'BOLERO_Neo', 'BOLERO_Retail', 'MHDR_BOLERO_CV_Retail']
    } 
    else if(localStorage.getItem('clientIDE') == 'MG MOTORS') {
      newClient = ['MG_MOTORS', 'MG_RETAIL']
    } 
    else if(localStorage.getItem('clientIDE') == 'AtherEnergyRSA') {
      newClient = ['ATHER_RSA']
    } */}
    return this.http.post<any>(`${this.localurl}api/getVendorNotAssignedBDCasesReport`,{"client" : client})
      .pipe(map(data=>{
        return data
      }))
  }

  getTicketReports(id){
    let client = localStorage.getItem('clientIDE')
    return this.http.post<any>(`${this.localurl}api/getDRSALiveTickets`,{"clientScheme": id})
    .pipe(map(data=>{
      return data
    }))
  }
}
